import { render, staticRenderFns } from "./SignUpInput.vue?vue&type=template&id=fbb6cf1e&scoped=true&"
import script from "./SignUpInput.vue?vue&type=script&lang=js&"
export * from "./SignUpInput.vue?vue&type=script&lang=js&"
import style0 from "./SignUpInput.vue?vue&type=style&index=0&id=fbb6cf1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb6cf1e",
  null
  
)

export default component.exports